module.exports = __webpack_public_path__ + "static/media/mockup-digi-1.3ace1b3e.jpg";